import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

interface CategoryDisplayProps {
    categoryId: string;
}

const CategoryDisplay: React.FC<CategoryDisplayProps> = ({ categoryId }) => {
    const { data: categories } = useQuery({
        queryKey: ['sighting-categories'],
        queryFn: async () => {
            const response = await api.sightingCategories.getAll();
            return response.data;
        }
    });

    const categoryName = categories?.find((cat: { id: string; name: string }) => cat.id === categoryId)?.name || 'Unknown';

    return <span>{categoryName}</span>;
};

export default CategoryDisplay; 